import React from "react";
import { ChevronDown, Check, Bot, Sparkles } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { useCredits } from "../context/CreditsContext";

const BADGE = {
  auto: "bg-sky-50 text-sky-700 border-sky-200",
  claude: "bg-orange-50 text-orange-700 border-orange-200",
  gpt: "bg-emerald-50 text-emerald-700 border-emerald-200",
  gemini: "bg-blue-50 text-blue-700 border-blue-200",
};
export const modelBadge = (id = "") => BADGE[Object.keys(BADGE).find((k) => id.startsWith(k))] || "bg-slate-100 text-slate-600 border-slate-200";

const TRIGGER = {
  ghost: "h-9 pl-2 pr-1.5 rounded-full text-[15px] text-slate-700 hover:bg-slate-100",
  pill: "h-8 pl-2.5 pr-2 rounded-full bg-slate-100 text-xs text-slate-700 hover:bg-slate-200",
};

export const ModelSelect = ({ value, onChange, testid = "model-selector-dropdown", align = "start", variant = "pill" }) => {
  const { models } = useCredits();
  const cur = models.find((m) => m.id === value);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" data-testid={testid} className={`flex items-center gap-1.5 font-medium transition-colors ${TRIGGER[variant]}`}>
          {value === "auto" ? <Sparkles size={variant === "ghost" ? 18 : 14} className="text-sky-600" /> : <Bot size={variant === "ghost" ? 19 : 14} strokeWidth={1.8} className="text-slate-800" />}
          <span className="truncate max-w-[84px] sm:max-w-[170px]">{cur?.label || "Choose model"}</span>
          <ChevronDown size={14} className="text-slate-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} className="w-72 max-h-[min(var(--radix-dropdown-menu-content-available-height),520px)] overflow-y-auto bg-white border-slate-200 p-1.5 rounded-2xl shadow-xl" data-testid="model-options-list">
        <DropdownMenuLabel className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">AI model</DropdownMenuLabel>
        {models.map((m) => (
          <DropdownMenuItem key={m.id} onSelect={() => onChange(m.id)} data-testid={`model-option-${m.id}`}
            className="flex items-start gap-3 p-2.5 rounded-xl cursor-pointer focus:bg-slate-50">
            <span className={`mt-0.5 px-1.5 py-0.5 rounded-md border text-[10px] font-mono ${modelBadge(m.id)}`}>{m.credits} cr</span>
            <span className="flex-1">
              <span className="block text-sm text-slate-900 font-medium">{m.label}{m.id === "claude-fable-5-1" && <span className="ml-1.5 px-1.5 py-0.5 rounded-full border border-sky-200 bg-sky-50 text-[10px] text-sky-700 align-middle">Top pick</span>}</span>
              <span className="block text-xs text-slate-500 leading-snug">{m.tagline}</span>
            </span>
            {m.id === value && <Check size={14} className="text-sky-600 mt-1" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ModelSelect;
